(function () {
  // Words that mark an item as "issue/defective"
  const ISSUE_WORDS = [
    'functional issue',
    'faulty',
    'defective',
    'for parts',
    'parts only',
    'dead',
    'broken',
    'cracked',
    'not working',
    'no power',
    'for scrap'
  ];

  function isIssueTitle(title) {
    if (!title) return false;
    const t = title.toLowerCase();
    return ISSUE_WORDS.some((w) => t.includes(w));
  }

  function parsePriceFromNode(li) {
    // Prefer data-price produced by Liquid (subunits: paise)
    const dp = li?.dataset?.price;
    if (dp && !Number.isNaN(+dp)) return +dp;

    // Fallback: read visible price text like ₹12,345 and strip non-digits
    const priceEl = li.querySelector('.price');
    if (!priceEl) return 0;
    const raw = priceEl.textContent || '';
    const digits = raw.replace(/[^\d]/g, '');
    return digits ? +digits : 0;
  }

  function sanitizeAndSort(list) {
    if (!list) return;

    // Collect <li> items
    const items = Array.from(list.children);

    // 1) Remove issue/defective items by title
    const clean = items.filter((li) => {
      const heading = li.querySelector('.predictive-search__item-heading');
      const title = heading ? heading.textContent.trim() : '';
      return !isIssueTitle(title);
    });

    // 2) Keep Shopify's RELEVANCE order (do NOT re-sort by price — that was
    //    overriding relevance and surfacing the most expensive unit first).

    // 3) Cap to 12 (change if you prefer)
    const MAX = 12;
    const trimmed = clean.slice(0, MAX);

    // 4) Paint
    list.replaceChildren(...trimmed);
  }

  // Run once now (in case markup is already on page)
  function runOnce() {
    const list = document.getElementById('predictive-search-results-products-list');
    if (list) sanitizeAndSort(list);
  }

  // Observe for changes whenever predictive search re-renders
  const observer = new MutationObserver(() => {
    // Delay a tick so inner HTML settles
    setTimeout(runOnce, 0);
  });

  function startObserving() {
    const wrapper = document.getElementById('predictive-search-results');
    if (!wrapper) return;
    observer.observe(wrapper, { childList: true, subtree: true });
  }

  // Kick off on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      startObserving();
      runOnce();
    });
  } else {
    startObserving();
    runOnce();
  }
})();